<template>
  <div class="loan">
    <div class="box box-primary">
      <div class="box-header with-border">
        <template v-if="$route.name==='ShowLoan'">
          <h3 class="box-title">
            {{ $t('label.showLoan') }}
          </h3>
        </template>
        <template v-else>
          <h3 class="box-title">
            {{ $t('label.newLoan') }}
          </h3>
        </template>
      </div>
      <div class="box-body">
        <div class="form-horizontal">
          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('loan_type') ? 'has-error' : '')"
          >
            <label class="required control-label col-sm-3">{{ $t('fields.loanType') }}</label>
            <div class="col-sm-9">
              <select
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.loan_type"
              >
                <option value="Payday">
                  {{ $t('fields.payday') }}
                </option>
                <option value="Personal">
                  {{ $t('fields.personal') }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('loan_type')"
              >
                {{ validations['loan_type'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('amount') ? 'has-error' : '')"
          >
            <label class="required col-sm-3 control-label">{{ $t('fields.amount') }}</label>
            <div class="col-sm-9">
              <div class="input-group">
                <span
                  class="input-group-addon"
                  id="basic-addon1"
                >$</span>
                <input
                  type="number"
                  :disabled="inputDisable"
                  class="form-control"
                  v-model="loan.amount"
                  :placeholder="$t('fields.amount')"
                >
              </div>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('amount')"
              >
                {{ validations['amount'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('duration') ? 'has-error' : '')"
          >
            <label class="required col-sm-3 control-label">{{ $t('fields.duration') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                :disabled="inputDisable"
                class="form-control"
                v-model="loan.duration"
                :placeholder="$t('fields.duration')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('duration')"
              >
                {{ validations['duration'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('purpose_loan') ? 'has-error' : '')"
          >
            <label class="required control-label col-sm-3">{{ $t('fields.purposeLoan') }}</label>
            <div
              class="col-sm-9"
              v-if="purposeLoans.length > 0"
            >
              <select
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.purpose_loan"
              >
                <optgroup
                  :label="`${$i18n.locale === 'km' ? parent.name_kh : parent.name}`"
                  :key="key"
                  v-for="(parent, key) in purposeLoans"
                >
                  <option
                    :value="child"
                    :key="ckey"
                    v-for="(child, ckey) in parent.children"
                  >
                    <template v-if="$i18n.locale === 'km'">
                      {{ child.name_kh }}
                    </template>
                    <template v-else>
                      {{ child.name }}
                    </template>
                  </option>
                </optgroup>
              </select>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('purpose_loan')"
              >
                {{ validations['purpose_loan'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('est_payback_date') ? 'has-error' : '')"
          >
            <label class="col-sm-3 control-label">{{ $t('fields.estPaybackDate') }}</label>
            <div class="col-sm-9">
              <datepicker
                :placeholder="$t('fields.estPaybackDate')"
                input-class="form-control"
                :disabled="inputDisable"
                format="dd/MM/yyyy"
                v-model="loan.est_payback_date"
              />
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('est_payback_date')"
              >
                {{ validations['est_payback_date'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('act_payback_date') ? 'has-error' : '')"
          >
            <label class="col-sm-3 control-label">{{ $t('fields.actPaybackDate') }}</label>
            <div class="col-sm-9">
              <datepicker
                :placeholder="$t('fields.actPaybackDate')"
                input-class="form-control"
                :disabled="inputDisable"
                format="dd/MM/yyyy"
                v-model="loan.act_payback_date"
              />
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('act_payback_date')"
              >
                {{ validations['act_payback_date'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('day_difference') ? 'has-error' : '')"
          >
            <label class="col-sm-3 control-label">{{ $t('fields.dayDifference') }}</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.day_difference"
                :placeholder="$t('fields.dayDifference')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('day_difference')"
              >
                {{ validations['day_difference'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('type_of_collacteral') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.typeOfCollateral') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                :disabled="inputDisable"
                class="form-control"
                v-model="loan.type_of_collacteral"
                :placeholder="$t('fields.typeOfCollateral')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('type_of_collacteral')"
              >
                {{ validations['type_of_collacteral'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('days_overdue') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.daysOverdue') }}</label>
            <div class="col-sm-9">
              <input
                type="number"
                :disabled="inputDisable"
                class="form-control"
                v-model="loan.days_overdue"
                :placeholder="$t('fields.daysOverdue')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('days_overdue')"
              >
                {{ validations['days_overdue'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('monthly_interest') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.monthlyInterest') }}</label>
            <div class="col-sm-9">
              <input
                type="number"
                :disabled="inputDisable"
                class="form-control"
                v-model="loan.monthly_interest"
                :placeholder="$t('fields.monthlyInterest')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('monthly_interest')"
              >
                {{ validations['monthly_interest'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('est_payback_amount') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.estPaybackAmount') }}</label>
            <div class="col-sm-9">
              <input
                type="number"
                :disabled="inputDisable"
                class="form-control"
                v-model="loan.est_payback_amount"
                :placeholder="$t('fields.estPaybackAmount')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('est_payback_amount')"
              >
                {{ validations['est_payback_amount'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('act_payback_amount') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.actPaybackAmount') }}</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.act_payback_amount"
                :placeholder="$t('fields.actPaybackAmount')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('act_payback_amount')"
              >
                {{ validations['act_payback_amount'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('month_year_payback') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.monthYearPayback') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.month_year_payback"
                :placeholder="$t('fields.monthYearPayback')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('month_year_payback')"
              >
                {{ validations['month_year_payback'][0] }}
              </span>
            </div>
          </div>
          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('principal') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.principal') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.principal"
                :placeholder="$t('fields.principal')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('principal')"
              >
                {{ validations['principal'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('interest_income') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.interestIncome') }}</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.interest_income"
                :placeholder="$t('fields.interestIncome')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('interest_income')"
              >
                {{ validations['interest_income'][0] }}
              </span>
            </div>
          </div>
          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('late_fee') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.lateFee') }}</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.late_fee"
                :placeholder="$t('fields.lateFee')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('late_fee')"
              >
                {{ validations['late_fee'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('collacteral_number') ? 'has-error' : '')"
          >
            <label class="control-label col-sm-3">{{ $t('fields.collateralNumber') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                :disabled="inputDisable"
                v-model="loan.collacteral_number"
                :placeholder="$t('fields.collateralNumber')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('collacteral_number')"
              >
                {{ validations['collacteral_number'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('is_repeat_borrower') ? 'has-error' : '')"
          >
            <label class="col-sm-offset-3 col-sm-9">
              <input
                type="checkbox"
                :disabled="inputDisable"
                value="true"
                v-model="loan.is_repeat_borrower"
              >
              {{ $t('fields.isRepeatBorrower') }}
            </label>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('provide_collateral') ? 'has-error' : '')"
          >
            <div class="col-sm-offset-3 col-sm-9">
              <label>
                <input
                  type="checkbox"
                  :disabled="inputDisable"
                  value="true"
                  v-model="loan.provide_collateral"
                >
                {{ $t('fields.provideCollateral') }}
              </label>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('provide_collateral')"
              >
                {{ validations['provide_collateral'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('money_sent') ? 'has-error' : '')"
          >
            <div class="col-sm-offset-3 col-sm-9">
              <label class="">
                <input
                  type="checkbox"
                  value="true"
                  :disabled="inputDisable"
                  v-model="loan.money_sent"
                >
                {{ $t('fields.moneySent') }}
              </label>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('money_sent')"
              >
                {{ validations['money_sent'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('payback') ? 'has-error' : '')"
          >
            <div class="col-sm-offset-3 col-sm-9">
              <label class="">
                <input
                  type="checkbox"
                  value="true"
                  :disabled="inputDisable"
                  v-model="loan.payback"
                >
                {{ $t('fields.payback') }}
              </label>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('payback')"
              >
                {{ validations['payback'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'col-md-12 form-group ' + (validations !== null && validations.hasOwnProperty('need_to_collect') ? 'has-error' : '')"
          >
            <div class="col-sm-offset-3 col-sm-9">
              <label class="">
                <input
                  type="checkbox"
                  :disabled="inputDisable"
                  name="need_to_collect"
                  value="true"
                  v-model="loan.need_to_collect"
                >
                {{ $t('fields.needToCollect') }}
              </label>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('need_to_collect')"
              >
                {{ validations['need_to_collect'][0] }}
              </span>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-offset-3 col-sm-9">
              <button
                class="btn btn-primary btn-sm"
                v-if="!inputDisable"
                @click="newLoan"
              >
                {{ $t('buttons.save') }}
              </button>
              <button
                class="btn btn-default btn-sm"
                @click="$router.back()"
              >
                {{ $t('buttons.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'Loan',
  metaInfo () {
    return {
      title: this.$t('string.loan'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: {
    Datepicker
  },
  data () {
    return {
      loan: {
        id: null,
        borrow_id: this.$route.params.borrowerId,
        amount: '',
        loan_type: 'Payday',
        purpose_loan: null,
        duration: '',
        start: null,
        end: null,
        lender_id: null,
        receiver_id: null,
        is_repeat_borrower: false,
        est_payback_date: null,
        act_payback_date: null,
        day_difference: null,
        need_to_collect: false,
        days_overdue: null,
        monthly_interest: null,
        est_payback_amount: null,
        month_year_payback: null,
        principal: null,
        interest_income: null,
        late_fee: null,
        money_sent: false,
        payback: false,
        provide_collateral: false,
        type_of_collacteral: null,
        collacteral_number: null
      },
      validations: null,
      baseApi: process.env.VUE_APP_API,
      locale: this.$i18n.locale,
      inputDisable: false,
      purposeLoans: []
    }
  },
  methods: {
    getLoan (id) {
      this.$isLoading(true)
      this.$axios.post(this.baseApi + '/api/v1/loan/get-loan', { id: id })
        .then((response) => {
          this.$isLoading(false)
          if (response.data.code === 1) {
            const result = response.data.data
            this.loan = result
            if (result && result.borrower && result.borrower.type) {
              this.loan.loan_type = result.borrower.type
            }
          }
        })
    },
    newLoan () {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, I am sure!'
      }).then((result) => {
        if (result.value) {
          this.$axios.post(this.baseApi + '/api/v1/loan/store', this.loan).then((response) => {
            if (response.data.code === 1) {
              this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.newLoan'))
              this.$router.back()
            }
            if (response.data.code === 0) {
              if (typeof (response.data.message) !== 'string') {
                this.validations = response.data.message
              }
            }
          })
        }
      })
    },
    getPurposeLoans () {
      this.$isLoading(true)
      this.$axios.post(this.baseApi + '/api/v1/loan/get-purpose-loans')
        .then((response) => {
          if (response.data.code === 1) {
            this.purposeLoans = response.data.data
          } else {
            this.purposeLoans = []
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  },
  mounted () {
    this.getPurposeLoans()
    this.$nextTick(() => {
      if (
        this.$route.params.hasOwnProperty('loanId') ||
        this.$route.params.hasOwnProperty('loanId') !== undefined
      ) {
        this.getLoan(this.$route.params.loanId)
      }
      if (this.$route.name === 'ShowLoan') {
        this.inputDisable = true
        $('select, input, textarea').attr('disabled', true)
      }
    })
  }
}
</script>

<style scoped>
.btn {
  margin-right: 5px;
}
</style>
